/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Profile_BdnInputs */



/**
* | output |
* | --- |
* | "BDN (Blu-ray)" |
*
* @param {Image_Export_Profile_BdnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_profile_bdn = /** @type {((inputs?: Image_Export_Profile_BdnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Profile_BdnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "de") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "it") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "es") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("BDN（蓝光）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BDN（Blu-ray）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
	return /** @type {LocalizedString} */ ("BDN (Blu-ray)")
});